export default __webpack_public_path__ + "static/media/like-icon-filled-rounded.ed8add47.svg";